<aside
  class="flex flex-col fixed top-0 left-0 bottom-0 min-w-[280px] bg-neutral-95 py-10"
>
  <a href="/" class="px-10">
    <img
      src="/assets/svg/coworkrz.svg"
      width="138"
      height="21"
      alt="Coworkrz Logo"
    />
  </a>
  <nav class="mt-24 flex flex-col">
    @for (link of links; track link) {
    <a
      [routerLink]="[link.link]"
      class="flex items-center px-10 mb-8 font-medium group"
      routerLinkActive="group is-active"
      [routerLinkActiveOptions]="{ exact: false }"
    >
      <div
        class="w-10 h-10 rounded-full border border-secondary-borders flex justify-center items-center mr-4 group-[.is-active]:text-white group-[.is-active]:bg-accent-base text-accent-base group-hover:bg-accent-base group-hover:text-white transition-all duration-300 ease-in-out"
      >
        <ng-icon [name]="link.icon"></ng-icon>
      </div>
      <span>{{ link.label }}</span>
    </a>
    }
  </nav>

  @if (user && user.profile) {
  <div class="mt-auto px-5">
    <button
      ui-admin-button
      class="flex items-center space-x-4"
      [uiMenuTriggerFor]="userMenu"
      yPosition="above"
      xPosition="after"
    >
      <ui-avatar
        [initials]="
          user.profile.firstName.charAt(0) + user.profile.lastName.charAt(0)
        "
        [size]="40"
      ></ui-avatar>
      <span class="font-medium">{{
        user.profile.firstName + ' ' + user.profile.lastName
      }}</span>
    </button>
  </div>
  }
</aside>

<ui-menu #userMenu>
  <div class="py-2">
    <button
      (click)="signOut()"
      class="hover:bg-slate-200 transition-all duration-300 px-8 py-2"
    >
      Logout
    </button>
  </div>
</ui-menu>
